module.exports = __webpack_public_path__ + "img/BB.5126b895.svg";